import { PropsWithChildren } from "react"
import './HeroButtonsContainer.css'

const HeroButtonsContainer = ({children}: PropsWithChildren) => {
  return <div className="react-hero-buttons-container">{children}</div>
}

export default HeroButtonsContainer